export default "https://cdn-static.gokick.com/assets/be369b33e14920b1856d71de34d484ec78759d8a/images/tangerine-flavor.074c3354820283b11da157ce9290935a.png";